import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FiltersButton(props) {
  return /*#__PURE__*/_jsxs(UILink, {
    "data-test-id": "filters-link",
    onClick: () => {
      Track.filtersOpened();
      props.onClick();
    },
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "filter"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.common.filters"
    })]
  });
}
FiltersButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(FiltersButton);